import { format, isValid, parse } from "date-fns";

export function parseDateDmY(value: string): Date | undefined {
	const trimmed = value.trim();
	if (!trimmed) return undefined;

	const d = parse(trimmed, "dd-MM-yyyy", new Date());
	if (isValid(d)) return d;

	return undefined;
}

export function formatDateDmY(date: Date): string {
	return format(date, "dd-MM-yyyy");
}

export function maskDateInputDmY(raw: string): string {
	const digits = raw.replace(/\D/g, "").slice(0, 8);

	if (digits.length === 0) return "";
	if (digits.length <= 2) return digits;
	if (digits.length <= 4) return `${digits.slice(0, 2)}-${digits.slice(2)}`;

	return `${digits.slice(0, 2)}-${digits.slice(2, 4)}-${digits.slice(4)}`;
}

export function countDigitsBeforeIndex(str: string, index: number): number {
	let n = 0;
	const end = Math.min(index, str.length);

	for (let i = 0; i < end; i++) {
		const c = str.charCodeAt(i);
		if (c >= 48 && c <= 57) n++;
	}

	return n;
}

export function selectionIndexAfterDigitCount(masked: string, digitCount: number): number {
	if (digitCount <= 0) return 0;
	let seen = 0;

	for (let i = 0; i < masked.length; i++) {
		const c = masked.charCodeAt(i);
		if (c >= 48 && c <= 57) {
			seen++;
			if (seen === digitCount) return i + 1;
		}
	}

	return masked.length;
}

export function normalizeDateInputDmY(raw: string): string {
	const trimmed = raw.trim();

	if (trimmed.length === 0) return "";
	if (/^\d{2}-\d{2}-\d{4}$/.test(trimmed)) {
		const parsed = parseDateDmY(trimmed);
		if (parsed) return formatDateDmY(parsed);
	}

	return maskDateInputDmY(raw);
}
